"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _client = require("@apollo/client");
var _authType = require("./auth/authType");
var core = _interopRequireWildcard(require("./auth/core"));
var _tokens = require("./auth/tokens");
var _clientLinks = require("./clientLinks");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var AUTH_TYPE = (0, _authType.getAuthType)();
var getApolloClient = function getApolloClient() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    modifyLinks = _ref.modifyLinks,
    cacheOptions = _ref.cacheOptions;
  if (localStorage.getItem(_tokens.REFRESH_TOKEN)) {
    core.refetchWhenExpires(localStorage.getItem(_tokens.REFRESH_TOKEN), _tokens.fetchRefreshedRefreshToken, _tokens.REFRESH_TOKEN);
  }
  var modifyLinksDefault = function modifyLinksDefault(_ref2) {
    var unauthenticatedErrorLink = _ref2.unauthenticatedErrorLink,
      accessTokenFetchingLink = _ref2.accessTokenFetchingLink,
      refreshTokenRequiringLink = _ref2.refreshTokenRequiringLink;
    return (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, _authType.authTypes.NONE, []), _authType.authTypes.SIMPLE, [_clientLinks.accessTokenRequiringLink, unauthenticatedErrorLink]), _authType.authTypes.FULL, [accessTokenFetchingLink, refreshTokenRequiringLink, unauthenticatedErrorLink])[AUTH_TYPE];
  };
  return new _client.ApolloClient({
    link: _client.ApolloLink.from([].concat((0, _toConsumableArray2["default"])((modifyLinks || modifyLinksDefault)({
      unauthenticatedErrorLink: _clientLinks.unauthenticatedErrorLink,
      accessTokenFetchingLink: _clientLinks.accessTokenFetchingLink,
      refreshTokenRequiringLink: _clientLinks.refreshTokenRequiringLink
    })), [_clientLinks.errorLink, _clientLinks.splitTransportLink])),
    cache: new _client.InMemoryCache(cacheOptions)
  });
};
var _default = exports["default"] = getApolloClient;